import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Table from "@/components/elements/Table/Table";
import { client } from "@/lib/sanity";

const ProjectDetailsPage = () => {
  const { slug } = useParams<{ slug: string }>();
  const [project, setProject] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
useEffect(() => {
  const fetchProjectDetails = async () => {
    setLoading(true);
    setError(null);

    try {
      const [sanityProject, localProjects] = await Promise.allSettled([
        client.fetch(
          `*[_type == "project" && slug.current == $slug][0]{
            title,
            category,
            "slug": slug.current,
            "imageUrl": image.asset->url,
            location,
            client,
            scopeOfWork,
            commencement,
            finalizationDate
          }`,
          { slug }
        ),
        fetch("/projects.json").then((res) => res.json()),
      ]);

      let finalProject = null;

      if (sanityProject.status === "fulfilled" && sanityProject.value) {
        finalProject = sanityProject.value;
      } else if (
        localProjects.status === "fulfilled" &&
        Array.isArray(localProjects.value)
      ) {
        const localMatch = localProjects.value.find((p: any) => p.slug === slug);
        finalProject = localMatch || null;
      }

      setProject(finalProject);
    } catch (err) {
      console.error(err);
      setError("Failed to fetch project");
    } finally {
      setLoading(false);
    }
  };
console.log("Current slug from URL:", slug);
  fetchProjectDetails();
}, [slug]);



  if (loading) return <p className="text-center text-gray-500 mt-24">Loading project details...</p>;
  if (error) return <p className="text-center text-red-600">{error}</p>;
  if (!project) return <p className="text-center">Project not found.</p>;

 return (
  <div className="max-w-4xl mx-auto mt-10 px-4 py-10">
    <img
      src={project.imageUrl || "/images/fallback.jpg"}
      alt={project.title}
      className=" my-10 object-contain mx-auto"
      style={{ maxWidth: "800px", maxHeight: "600px", width: "100%", height: "auto" }}
    />

    <h1 className="text-2xl font-bold my-4 h1">{project.title}</h1>

    <div className="overflow-x-auto w-full">
      <Table 
        items={{
          headings: [],
          rows: [
            ["Location", project.location || "N/A"],
            ["Client", project.client || "N/A"],
            ["Commencement Date", project.commencement || "N/A"],
            ["Finalization Date", project.finalizationDate || "N/A"],
            ["Scope of Work", project.scopeOfWork || "N/A"],
          ],
        }}
      />
    </div>
  </div>
);

};

export default ProjectDetailsPage;
